module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAYAAABit09LAAAAAXNSR0IArs4c6QAAANBJREFUKFOtkrEOwWAUhc9p00QiiNlr2I12D9DVOxn8BoPEUgxGvIGtLTEaREgkxIAeaSyNtPIP7nq/fDf33sP+ZLF2xLPo9NzSfea32zfkFE2wPAG6gBx64vh2KEfdbvPxzdIEqxcgCtoQnLoJjd9phTng8gqgnDYEhSKN99L8fqzEWXNqvACqfkA8AUUE599mmmBxBljPjsoz54KAHgLi1OzhOWjU3E0B+PFL2tLhiAnCnyDAREp2IPb/AS1GWy5TcB7rg9u/0DoUdjGzDe4bWNLO/a6GVzcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/triangle_select.png
// module id = tc7O
// module chunks = 1